import NavBar from "../components/NavBar";
import img1 from '../images/why-us-img-1.jpeg';

const ServicesPage = () => {
  const colors = {
    brown: "#A3582A",
    green: "#8C8660",
    beige: "#EFE5C6",
    yellow: "#E9BA67",
    lightGreen: "#E4E2D5",
    gray: "#5E6065",
  };
  const services = [
    {
      title: "Vacation Home Rentals",
      description:
        "Premium listings with optimal exposure across global booking platforms.",
      icon: (
        <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
      ),
    },
    {
      title: "Full Property Management",
      description:
        "360-degree operational oversight, from onboarding to guest checkout.",
      icon: (
        <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
        </svg>
      ),
    },
    {
      title: "Cleaning & Maintenance",
      description:
        "Impeccable housekeeping standards, regular inspections, and on-demand repairs.",
      icon: (
        <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      ),
    },
    {
      title: "Smart Pricing (AI-Based)",
      description:
        "Dynamic, data-driven pricing models ensuring maximum profitability.",
      icon: (
        <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" />
        </svg>
      ),
    },
    {
      title: "AI-Powered Guest Communications",
      description:
        "24/7 guest support via automated chatbots and live assistance.",
      icon: (
        <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
        </svg>
      ),
    },
  ];

  return (
    <div className="min-h-screen">
      {/* Header/Navigation */}
      <NavBar />
      
      <div className="relative py-12 sm:py-16 md:py-20 overflow-hidden">
        {/* Luxurious Background Elements */}
        <div className="absolute inset-0 bg-white z-0"></div>

        {/* Soft Glow Background - Adjusted size for mobile */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] h-[300px] sm:w-[450px] sm:h-[450px] md:w-[600px] md:h-[600px] bg-primary/10 rounded-full blur-3xl pointer-events-none"></div>

        {/* Background Texture Overlay */}
        <div
          className="absolute inset-0 z-5 opacity-5 mix-blend-overlay"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23a3582a' fill-opacity='0.4' fill-rule='evenodd'%3E%3Ccircle cx='3' cy='3' r='1'/%3E%3Ccircle cx='13' cy='13' r='1'/%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: "8px 8px",
          }}
        ></div>

        {/* Subtle Diagonal Line Accents - hidden on smallest screens */}
        <div className="absolute top-0 left-1/4 h-full w-px bg-gradient-to-b from-transparent via-primary/10 to-transparent hidden sm:block"></div>
        <div className="absolute top-0 right-1/4 h-full w-px bg-gradient-to-b from-transparent via-primary/15 to-transparent hidden sm:block"></div>

        <div className="container mx-auto px-4 sm:px-6 relative z-10">
          <div className="text-center reveal-item">
            <div className="inline-block px-4 sm:px-6 py-1 sm:py-2 rounded-full mb-4 sm:mb-8 bg-white/80 backdrop-blur-md border border-primary/20 shadow-md">
              <p
                className="font-futura text-xs sm:text-sm flex items-center"
                style={{ color: colors.brown }}
              >
                <span
                  className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full mr-1.5 sm:mr-2 pulse-animation"
                  style={{ backgroundColor: colors.brown }}
                ></span>
                 Takeaya Services
              </p>
            </div>

            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light mb-4 sm:mb-6 tracking-tight staggered-title font-ivyMode" style={{ color: "#A3582A" }}>
              <span className="block reveal-heading">Our Premium Services at</span>
              <span className="relative inline-block reveal-heading delay-200">
                <span className="absolute -rotate-2 inset-0 rounded-md heading-background" style={{ backgroundColor: 'rgba(233, 186, 103, 0.2)' }}></span>
                <span className="relative" style={{ color: "#A3582A" }}>Takeaya</span>
              </span>
            </h2>

            <p
              className="text-sm sm:text-base md:text-lg lg:text-xl max-w-3xl mx-auto reveal-paragraph font-futura"
              style={{ color: colors.gray }}
            >
              Immerse yourself in unparalleled comfort and sophistication, where
              every detail is crafted to exceed your expectations.
            </p>
          </div>
        </div>

        <style jsx>{`
        /* Particle Animation - Smaller on mobile */}
        .particle-container {
          overflow: hidden;
          pointer-events: none;
        }

        .particle {
          position: absolute;
          border-radius: 50%;
          background: radial-gradient(
            circle at center,
            rgba(163, 88, 42, 0.4),
            rgba(163, 88, 42, 0)
          );
          animation-timing-function: cubic-bezier(0.2, 0.3, 0.8, 0.7);
          animation-iteration-count: infinite;
          opacity: 0;
        }

        .particle-1 {
          width: 40px;
          height: 40px;
          left: 10%;
          top: 20%;
          animation: floatParticle 15s 0s infinite;
        }

        .particle-2 {
          width: 30px;
          height: 30px;
          left: 85%;
          top: 15%;
          animation: floatParticle 18s 2s infinite;
        }

        .particle-3 {
          width: 50px;
          height: 50px;
          left: 20%;
          top: 70%;
          animation: floatParticle 20s 1s infinite;
        }

        .particle-4 {
          width: 20px;
          height: 20px;
          left: 65%;
          top: 80%;
          animation: floatParticle 12s 3s infinite;
        }

        /* Larger particles on desktop */
        @media (min-width: 640px) {
          .particle-1 {
            width: 80px;
            height: 80px;
          }
          
          .particle-2 {
            width: 60px;
            height: 60px;
          }
          
          .particle-3 {
            width: 100px;
            height: 100px;
          }
          
          .particle-4 {
            width: 40px;
            height: 40px;
          }
        }

        @keyframes floatParticle {
          0% {
            transform: translate(0, 0);
            opacity: 0;
          }
          25% {
            opacity: 0.2;
          }
          50% {
            transform: translate(20px, -30px);
            opacity: 0.1;
          }
          75% {
            opacity: 0.15;
          }
          100% {
            transform: translate(0, 0);
            opacity: 0;
          }
        }

        /* 3D Card Effect - Toned down on mobile */}
        .perspective-container {
          perspective: 1000px;
        }

        .property-card-3d {
          transform-style: preserve-3d;
          transition: transform 0.5s ease;
        }
        
        /* Reduce 3D effect on mobile due to touchscreens */
        @media (hover: hover) {
          .property-card-3d:hover {
            transform: rotateY(-5deg) rotateX(5deg);
          }
          
          .property-card-3d:hover .property-card-inner {
            box-shadow: 0 15px 30px rgba(163, 88, 42, 0.2);
          }
          
          .property-card-3d:hover .property-image {
            transform: scale(1.05);
          }
        }
        
        /* For mobile devices with touchscreens */
        @media (hover: none) {
          .property-card-3d:active .property-image {
            transform: scale(1.02);
            transition: transform 0.3s ease;
          }
        }

        /* Reveal Animations - Speed up on mobile */}
        .reveal-item {
          opacity: 0;
          animation: revealUp 0.6s ease-out forwards;
        }

        .delay-200 {
          animation-delay: 0.2s;
        }

        .delay-400 {
          animation-delay: 0.3s;
        }

        .delay-600 {
          animation-delay: 0.4s;
        }

        /* Faster animations on mobile */
        @media (min-width: 640px) {
          .reveal-item {
            animation-duration: 0.8s;
          }
          
          .delay-400 {
            animation-delay: 0.4s;
          }
          
          .delay-600 {
            animation-delay: 0.6s;
          }
        }

        .reveal-heading {
          opacity: 0;
          animation: revealLeft 0.8s ease-out forwards;
        }

        .heading-background {
          animation: drawBackground 0.5s ease-out forwards 0.3s;
          width: 0;
        }

        .reveal-paragraph {
          opacity: 0;
          animation: revealUp 0.8s ease-out forwards 0.4s;
        }

        @keyframes revealUp {
          from {
            transform: translateY(30px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }

        @keyframes revealLeft {
          from {
            transform: translateX(-30px);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }

        @keyframes drawBackground {
          from {
            width: 0;
          }
          to {
            width: 100%;
          }
        }

        /* Pulse Animation - Reduced size on mobile */}
        .pulse-animation {
          animation: pulse 2s infinite;
        }

        @keyframes pulse {
          0% {
            transform: scale(0.95);
            box-shadow: 0 0 0 0 rgba(163, 88, 42, 0.7);
          }
          
          70% {
            transform: scale(1);
            box-shadow: 0 0 0 5px rgba(163, 88, 42, 0);
          }
          
          100% {
            transform: scale(0.95);
            box-shadow: 0 0 0 0 rgba(163, 88, 42, 0);
          }
        }
        
        /* Larger pulse on desktop */
        @media (min-width: 640px) {
          @keyframes pulse {
            0% {
              transform: scale(0.95);
              box-shadow: 0 0 0 0 rgba(163, 88, 42, 0.7);
            }
            
            70% {
              transform: scale(1);
              box-shadow: 0 0 0 10px rgba(163, 88, 42, 0);
            }
            
            100% {
              transform: scale(0.95);
              box-shadow: 0 0 0 0 rgba(163, 88, 42, 0);
            }
          }
        }
      `}</style>
      </div>
      
      {/* Main Services Section - Responsive layout and spacing */}
      <section className="py-8 sm:py-12 md:py-16">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="max-w-3xl mx-auto text-center mb-8 sm:mb-12">
            <h2 className="font-ivyMode text-2xl sm:text-3xl text-primary mb-3 sm:mb-4">
              Comprehensive Property Services
            </h2>
            <p className="text-gray-700 font-futura text-sm sm:text-base">
              Each of our services is designed to make property ownership
              effortless and profitable, while ensuring guests enjoy exceptional
              experiences that bring them back time after time.
            </p>
          </div>

          {/* Services Grid - Responsive columns */}
          <div className="text-start grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mb-12 sm:mb-16">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-white rounded-lg shadow-md hover:shadow-lg transition-all p-4 sm:p-6 border border-amber-100 group"
              >
                <div className="flex items-center mb-3 sm:mb-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-amber-100 rounded-full flex items-center justify-center text-primary mr-3 sm:mr-4 group-hover:bg-amber-600 group-hover:text-white transition-all">
                    {service.icon}
                  </div>
                  <h3 className="font-ivyMode text-base sm:text-lg text-primary">
                    {service.title}
                  </h3>
                </div>
                <p className="text-gray-600 font-futura text-sm sm:text-base">
                  {service.description}
                </p>
              </div>
            ))}
          </div>

          {/* Value Proposition - Responsive grid and sizing */}
          <div className="bg-white rounded-lg shadow-md p-6 sm:p-8 md:p-12 border border-amber-100 mb-12 sm:mb-16">
            <div className="grid md:grid-cols-2 gap-6 sm:gap-8">
              <div>
                <h3 className="font-ivyMode text-xl sm:text-2xl text-primary mb-3 sm:mb-4">
                  Why Choose Our Services
                </h3>
                <p className="text-gray-700 mb-4 sm:mb-6 font-futura text-sm sm:text-base">
                  Our comprehensive approach to service delivery ensures both
                  property owners and guests receive exceptional care and
                  attention.
                </p>
                <ul className="space-y-2 sm:space-y-3">
                  {[
                    "Maximize rental income through AI-driven pricing",
                    "Reduce operational hassles with end-to-end management",
                    "Enhance property appeal with expert styling",
                    "Gain peace of mind with rigorous maintenance",
                    "Access real-time performance analytics",
                  ].map((item, i) => (
                    <li key={i} className="flex items-start">
                      <svg
                        className="w-4 h-4 sm:w-5 sm:h-5 text-amber-600 mr-2 mt-1 flex-shrink-0"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 13l4 4L19 7"
                        ></path>
                      </svg>
                      <span className="text-gray-700 font-futura text-sm sm:text-base">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
              
              {/* Responsive image container */}
              <div className="relative rounded-lg overflow-hidden h-48 sm:h-64 md:h-auto mt-4 md:mt-0">
                <img
                  src={img1}
                  alt="Luxury property"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end">
                  <div className="p-4 sm:p-6 w-full">
                    <div className="bg-white/90 backdrop-blur-sm rounded-lg p-3 sm:p-4 inline-block">
                      <div className="text-amber-700 font-serif text-lg sm:text-xl">
                        95% Occupancy Rate
                      </div>
                      <div className="text-gray-600 text-xs sm:text-sm">
                        Average for properties in our portfolio
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;